import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "stretch",
      gap: spacing.xxs,
      padding: spacing.xxs,
      backgroundColor: theme.transfers.option.background.default,
      borderRadius: constants.radius.view,
    },
    option: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: `${spacing.xs}px ${spacing.xxs}px`,
      borderRadius: constants.radius.view,
      cursor: "pointer",
      userSelect: "none",
      textAlign: "center",
    },
    optionSelected: {
      backgroundColor: theme.transfers.option.background.selected,
    },
    label: {
      fontSize: 14,
      fontWeight: 500,
      margin: 0,
      whiteSpace: "nowrap",
      color: theme.transfers.option.text.default,
    },
    labelSelected: {
      color: theme.transfers.option.text.selected,
    },
  };

  return styles;
};
